// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__1tA9O","resultsContainer":"App_resultsContainer__rYVfh","results":"App_results__15ysh","resultsLabel":"App_resultsLabel__2lW0_"};